import Checkbox from 'components/global/Checkbox';
import Radio from 'components/global/Radio';
import Typography from 'components/global/Typography';

import * as S from './styled/SelectButton.styled';

/**
 * @typedef {object} SelectButtonProps
 * @params {SelectButtonProps} props
 * @property {function} onClick - The click event handler.
 * @property {boolean} [checked=false] - Whether the button is checked.
 * @property {string} [image] - The url of the image displayed in the button.
 * @property {string} [title] - The title text displayed in the button.
 * @property {string} [description] - The description text displayed under the title.
 * @property {boolean} [disabled=false] - If true, the button will be disabled.
 * @property {boolean} [error=false] - If true, the button should display an error state.
 * @property {'checkbox' | 'radio'} [variant='checkbox'] - Variant of the button. Can be 'checkbox' or 'radio'.
 * @property {JSX.Element} [badge] -  An optional badge component to display next to the title
 * @returns {JSX.Element}
 */

const SelectButton = (props) => {
	const {
		onClick,
		checked = false,
		image,
		title,
		description,
		disabled = false,
		error = false,
		variant = 'checkbox',
		badge,
		...moreProps
	} = props;

	const SelectedInput = variant === 'radio' ? Radio : Checkbox;

	return (
		<S.StyledButton
			fullWidth
			variant="select-button"
			className={`${error ? 'error' : ''} ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}
			disabled={disabled}
			onClick={onClick}
			{...moreProps}>
			<S.StyledCard>
				<S.Container>
					{image && <S.StyledImage url={image} width="6rem" height="6rem" />}
					<S.ContentWrapper>
						<S.Title>
							<Typography variant="p2" noWrap fontWeight="500">
								{title}
							</Typography>
							{badge}
						</S.Title>

						{description && (
							<Typography variant="p3" noWrap color="var(--content-3)">
								{description}
							</Typography>
						)}
					</S.ContentWrapper>
				</S.Container>
				<S.InputWrapper>
					<SelectedInput readOnly error={error} checked={checked} disabled={disabled} />
				</S.InputWrapper>
			</S.StyledCard>
		</S.StyledButton>
	);
};

export default SelectButton;
